var utils = {
    log: function(object) {
        if (process.env.NODE_ENV !== "production") {
            console.log(object);
        }
    },
    toTitleCase: function(str) {
        return str.replace(/\w\S*/g, function(txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    }
};

export { utils }
